import { thumbHashToDataURL } from 'thumbhash';

export function convertThumbhashToDataURL(base64Hash?: string): string | undefined {
    if (!base64Hash) {
        return undefined;
    }

    const decodedBytes = atob(base64Hash);
    const hash = new Uint8Array(decodedBytes.length);

    for (let i = 0; i < decodedBytes.length; i++) {
        hash[i] = decodedBytes.charCodeAt(i);
    }

    return thumbHashToDataURL(hash);
}
